import React from "react";
import "./PdfImageBox.css";

class PdfImageBox extends React.Component {
  constructor(props) {
    super(props);

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleClicked = this.handleClicked.bind(this);
    this.delayClicked = getClickHandler(this.handleClicked);

    this.state = {
      isHovering: false
    };
  }

  handleMouseEnter() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  handleClicked() {
    const { image, handleClicked } = this.props;
    handleClicked(image);
  }

  render() {
    const {
      image,
      isSelecting,
      width,
      realWidth,
      displayMode,
      previewing,
      invisible,
      highlight
    } = this.props;
    const { isHovering } = this.state;

    if (image == null) {
      return null;
    }

    if (realWidth <= 0) {
      return null;
    }

    const scaleX = realWidth / width;

    let divStyle = {
      left: 0,
      top: 0,
      width: image.width + "px",
      height: image.height + "px",
      transform: `scale(${scaleX}) matrix(
        ${image.transform[0]}, 
        ${image.transform[1]}, 
        ${image.transform[2]}, 
        ${image.transform[3]}, 
        ${image.transform[4]}, 
        ${image.transform[5]})`
    };

    let className;
    if (previewing) {
      className = "pdf_image_box_border_previewing";
    } else if (!isSelecting && isHovering) {
      className = "pdf_image_box_border_focus";
    } else if (highlight) {
      className = "pdf_image_box_border_focus";
    } else if (displayMode) {
      className = "pdf_image_box_border_none";
    } else if (invisible) {
      className = "pdf_image_box_border_hide";
    } else {
      className = "pdf_image_box_border";
    }

    return (
      <div
        className={className}
        style={divStyle}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.delayClicked}
      />
    );
  }
}

function getClickHandler(onClick) {
  let timeoutID = null;
  const delay = 250;

  return function(event) {
    if (!timeoutID) {
      timeoutID = setTimeout(function() {
        onClick(event);
        timeoutID = null;
      }, delay);
    } else {
      clearTimeout(timeoutID);
      timeoutID = null;
    }
  };
}

export default PdfImageBox;
